"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  enabled: null,
  type: null,
  bodyEndHtml: null
}, 'Drift');

exports.default = _default;
module.exports = exports.default;